import { CURRENCY_SYMBOL } from '@constants/index';
import { numberWithSpaces } from '@utils/numberWithSpaces';

export function formatPrice(value: number) {
  const formetedValue = numberWithSpaces(value);
  return `${formetedValue} ${CURRENCY_SYMBOL}`;
}
